export const WidgetTeamScheduleTimeLabelLayout = {
  width: 73,
};
